import '../../style/index.less';
import './index.less';


//////////////////
// WEBPACK FOOTER
// ./node_modules/_antd@3.9.2@antd/es/badge/style/index.js
// module id = b4u7
// module chunks = 12 13 14 15 16 17 18